export const defaultListsData = [
    {
        title:"Default lists",
        subTitle:[
            {
                text: 'Use the ',
                code: '.list-group '
            },
            {
                text: 'define the list of items. and used ',
                code: '.list-group-item '
            },
            {
                text: 'to indicate the current content.'
            }
        ],
        listItem:[
            "Logo Design","Web Design & Development","E-Commerce",
            "SEO"
        ]
    },
    {
        title:"Active lists",
        subTitle:[
            {
                text: 'Use',
                code: '.active '
            },
            {
                text: 'to a',
                code: '.list-group-item'
            },
            {
                text: ' to indicate the current active.'
            }
        ],
        listItem:[
            "UI Kits","Wow Animations","Apex Charts",
            "Starter Kits"
        ]
    },
    {
        title:"Flush lists",
        subTitle:[
            {
                text: 'Use ',
                code: ' .list-group-flush'
            },
            {
                text: ' to remove some borders and rounded corners to render list group items.'
            }
        ],
        class:"flush",
        listItem:[
            "PRODUCT","PRODUCT DETAILS","CART",
            "CHECKOUT"
        ]
    }
]

export const contextualListsData = [
    {
        color:"secondary",
        title:"Secondary"
    },
    {
        color:"success",
        title:"Success"
    },
    {
        color:"danger",
        title:"Danger"
    },
    {
        color:"info",
        title:"Info"
    },
    {
        color:"white",
        title:"White"
    },
    {
        color:"dark",
        title:"Dark"
    }
]

export let horizontalListData = [
    {
        size:"md",
        listData:[
           {
            class:"border-left-secondary",
            title:"Basic table"
           } ,
           {
            title:"Sizing table"
           } ,
           {
            title:"Border table"
           } ,
           {
            title:"Basic inputs"
           } ,
           {
            title:"Form validations"
           } 
        ]
    },
    {
        size:"lg",
        listData:[
           {
            class:"border-left-warning",
            title:"Flat style"
           } ,
           {
            title:"Edge style"
           } ,
           {
            title:"Button group"
           } ,
           {
            title:"Rating"
           } ,
           {
            title:"Crypto"
           } 
        ]
    },
    {
        size:"xl",
        listData:[
           {
            class:"border-left-success",
            title:"Blog"
           } ,
           {
            title:"Blog details"
           } ,
           {
            title:"Blog single"
           } ,
           {
            title:"Order history"
           } 
        ]
    },
    {
        size:"xxl",
        listData:[
           {
            class:"border-left-info",
            title:"Gallery grid"
           } ,
           {
            title:"Gallery desc"
           } ,
           {
            title:"Masonry Desc"
           } 
        ]
    }
]

export const custonListData = [
    {
        class: 'active bg-primary',
        head: 'Molly Boake',
        mail: 'MollyBoake@rhyta.com',
        image: 'user/1.jpg',
        span: '5 days ago',
        subtext: "Next step is to choose a tone of voice for your content type. From casual to convincing, pick one from 20+ tones in the dropdown.Why did we say “snag eyeballs” instead of “get attention?” Why do we say “brick-and-mortar words” instead of “concrete words?” Because, in your email subject lines, it’s better to use words that people can picture.",
        follower: '20K Followers'
    },
    {
        class: 'list-hover-primary',
        head: 'Gabrielle Fahey',
        mail: 'GabrielleFahey@dayrep.com',
        image: 'user/3.png',
        span: '10 days ago',
        subtext: "Your aim with this blog is to advertise yourself and your services in blog design. That means it's vital to create content about just that: blog design. Anything else on your page may act as a distraction to your potential customers, and you don't want that!",
        follower: '100 Followers'
    },
    {
        class: 'list-hover-primary',
        head: 'Lucinda Moseley',
        mail: 'LucindaMoseley@teleworm.us',
        image: 'user/2.jpg',
        span: '3 days ago',
        subtext: "People who are looking to hire a web designer may not know what to look out for. This will give you a chance to prove your trustworthiness by providing potential customers with advice and will let you sell your services by highlighting their best qualities.",
        follower: '23M Followers'
    }
]

export const listCheckboxData = [
    {
        class: 'checkbox-secondary',
        labelClass: 'txt-secondary',
        text: "Auto Update"
    },
    {
        class: 'checkbox-success',
        labelClass: 'txt-success',
        text: "Don't check auth key"
    },
    {
        class: 'checkbox-warning',
        labelClass: 'txt-warning',
        text: "Success all"
    }
]

export const listRadioData = [
    {
        class: 'checkbox-primary',
        text: ' Read a book'
    },
    {
        class: 'checkbox-success',
        text: ' Learn to code '
    },
    {
        class: 'checkbox-info',
        text: ' Drink more water'
    }
]

export const numberListData = [
    {
        class: 'txt-danger',
        text: 'Solve your problem with us'
    },
    {
        class: 'txt-success',
        text: 'Certified Professionals'
    },
    {
        class: 'txt-warning',
        text: 'Growth-Driven '
    }
]

export const badgeListData= [
    {
        text: 'Lola Stanford',
        badgeClass: 'bg-danger text-white',
        badgeText: 'Issue'
    },
    {
        text: 'Caitlin Coungeau',
        badgeClass: 'bg-primary text-white',
        badgeText: 'Social'
    },
    {
        text: 'Graciela W. McClaran',
        badgeClass: 'bg-danger text-white',
        badgeText: 'Issue'
    }
]

export const disableListData = [
    {
        class: 'list-hover-secondary',
        img: 'user/3.png',
        text: 'Gloria D. Acheson'
    },
    {
        class: 'disabled',
        img: 'user/2.jpg',
        text: 'Sharon C. Obrien'
    },
    {
        class: 'disabled',
        img: 'user/5.jpg',
        text: 'Bryan A. Owens'
    }
]

export const scrollableListData = [
    {
        img: 'user/10.jpg',
        head: 'Gabrielle Fahey',
        mail: 'GabrielleFahey@dayrep.com',
        small: '10 days ago'
    },
    {
        img: 'user/2.jpg',
        head: 'Lucinda Moseley',
        mail: 'LucindaMoseley@teleworm.us',
        small: '3 days ago'
    },
    {
        img: 'user/12.png',
        head: 'Francis K. Henriques',
        mail: 'FrancisKHenriques@teleworm.us',
        small: '2 days ago'
    },
    {
        img: 'user/14.png',
        head: 'Jose A. Seay',
        mail: 'JoseASeay@rhyta.com',
        small: '15 days ago'
    },
    {
        img: 'user/3.jpg',
        head: 'Phil F. Cunningham',
        mail: 'PhilFCunningham@dayrep.com',
        small: '6 days ago'
    },
    {
        img: 'user/7.jpg',
        head: 'Richard E. Johnson',
        mail: 'RichardEJohnson@teleworm.us',
        small: '20 days ago'
    },
    {
        img: 'user/2.png',
        head: 'Lawrence L. Nash',
        mail: 'LawrenceLNash@jourrapide.com',
        small: '8 days ago'
    }
]